// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"296":"7e26156e","408":"242d2e46","453":"141d864c","479":"7b36d7b6","521":"92cfec52","712":"dc45d1bc","778":"c72e0ae5","821":"0cec88ed"}[chunkId] + ".chunk.js";
};